<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{ $lang('在线文档') }}</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div
      class="main-r-bottom"
      v-show="mainStatus === 'online'"
    >
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div
      class="main-r-bottom"
      v-show="mainStatus === 'apiTest'"
    >
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import { OPEN_API_TEST, OPEN_API_PRO } from '@/constants/index'
const apiUrlTest = 'order/addOrder';
export default {
  components: { onlineDoc, apiTestDoc },
  data () {
    const that = this
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        isShowCountryCode: true,
        //接口描述
        apiDesc: `发货客户下单后J&T接口接收数据并处理的功能。`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
        postDataList: [

          //   请求头参数
          {
            title: 'Headers',
            value: [
              { name: "apiAccount", type: "Number", require: "Y", normal: "670582903876358197", describe: "接入方可在控制台的应用内查看apiAccount" },
              { name: "digest", type: "String", require: "Y", normal: "mdEHkGNxskNLVu4P+Ak11A==", describe: "签名字符串,请在签名工具内获取", },
              { name: "timestamp", type: "Number", require: "Y", normal: "", describe: `<p>${this.$lang('时间戳，毫秒')}</p><p>${this.$lang('时区：东七区 泰国')}</p>`, isHtml: true },
            ]
          },
          {
            title: '请求参数',
            value: [
              { name: "bizContent", type: "String", require: "Y", normal: this.$lang("业务参数"), describe: "业务参数模块内json格式的string类型", },
            ]
          },
          {
            title: "业务参数",
            value: [
              { name: "actionType", type: "String", require: "Y", normal: "add", describe: `<p>${that.$lang('操作类型')}:</p><p>${that.$lang('add=新增')},</p>`, isHtml: true },
              { name: "customerCode", type: "String(30)", require: "Y", normal: "VIP111111101", describe: "客户编码（联系出货网点提供）" },
              { name: "password", type: "String(100)", require: "Y", normal: this.$lang("明文密码:H5CD3zE6"), describe: "请在签名工具内获取接口的password" },
              { name: "txlogisticId", type: "String(50)", require: "Y", normal: "TESTID000001", describe: "客户订单号" },
              { name: "orderType", type: "String", require: "Y", normal: "1", describe: `<p>${that.$lang('订单类型')}:</p><p>${that.$lang('1=普通订单')}</p><p>${that.$lang('2=退货订单 默认传1')}</p>`, isHtml: true },
              { name: "serviceType", type: "String(30)", require: "Y", normal: "1", describe: `<p>${that.$lang('服务类型')}:</p><p>${that.$lang('1=上门取件')}</p><p>${that.$lang('6=上门寄件')}</p><p>${that.$lang('7=仓库取件')}</p>`, isHtml: true },
              { name: "shopId", type: "String(30)", require: "N", normal: "", describe: "商家ID" },
              { name: "shopName", type: "String(30)", require: "N", normal: "", describe: "商家名称" },
              { name: "expressType", type: "String", require: "Y", normal: "EZ", describe: `<p>${that.$lang('快件类型')}:</p><p>${that.$lang('BUK 大件')}</p><p>${that.$lang('FP 水果件')}</p><p>${that.$lang('EZ 标准快递')}</p>`, isHtml: true },
              { name: "deliveryType", type: "Int", require: "Y", normal: "1", describe: `<p>${that.$lang('派送类型')}:</p><p>${that.$lang('1=正常派送')}</p><p>${that.$lang('2=自提件')}</p><p>${that.$lang('默认为：1')}</p>`, isHtml: true },
              { name: "sender", type: "Object", require: "Y", normal: "", describe: "寄件人信息" },
              { name: "receiver", type: "Object", require: "Y", normal: "", describe: "收件人信息" },
              { name: "createOrderTime", type: "String(20)", require: "Y", normal: "", describe: "订单创建时间，24 小时 :yyyy-MM-dd HH:mm:ss" },
              { name: "items", type: "Object", require: "N", normal: "", describe: "物品信息" },
              { name: "packageInfo", type: "Object", require: "Y", normal: "", describe: "包裹信息" },
              { name: "sendStartTime", type: "String", require: "Y", normal: "", describe: "物流公司上门取货开始时间yyyy-MM-dd HH:mm:ss" },
              { name: "sendEndTime", type: "String", require: "Y", normal: "", describe: "客户物流公司上门取货结束时间yyyy-MM-dd HH:mm:ss" },
              { name: "offerFeeInfo", type: "Object", require: "N", normal: "", describe: "保价信息" },
              { name: "codInfo", type: "Object", require: "N", normal: "", describe: "COD信息" },
              { name: "remark", type: "String(200)", require: "N", normal: "", describe: "备注" },
              { name: "goodsValue", type: "Bigdecimal", require: "N", normal: "38.00", describe: "包裹总价值，两位小数，单位THB" },
              { name: "isSmallEcom", type: "String", require: "N", normal: "", describe: `<p>${that.$lang('1=是，shopid必填')}:</p><p>${that.$lang('0=否')}</p>`, isHtml: true }
            ]
          },
          {
            title: "sender参数",
            value: [
              { name: "name", type: "String(100)", require: "Y", normal: "Mr.Blue", describe: "寄件人姓名" },
              { name: "postCode", type: "String(10)", require: "Y", normal: "59200", describe: "寄件邮编" },
              { name: "mobile", type: "String(30)", require: "Y", normal: "", describe: "寄件手机号" },
              { name: "phone", type: "String(30)", require: this.$lang("不能和手机号同时为空"), normal: "", describe: "寄件电话" },
              { name: "area", type: "String(60)", require: "N", normal: "", describe: "寄件乡镇" },
              { name: "city", type: "String(60)", require: "Y", normal: "", describe: "寄件城市" },
              { name: "prov", type: "String(60)", require: "Y", normal: "TEST ADDRESS", describe: "寄件省" },
              { name: "address", type: "String(200)", require: "Y", normal: "TEST ADDRESS", describe: "寄件详细地址" },
              { name: "countryCode", type: "String(10)", require: "N", normal: "THA", describe: "国家/地区code，例如CHN, BWN, IDN三字码;THA，泰国默认THA" },
            ]
          },
          {
            title: "receiver参数",
            value: [
              { name: "name", type: "String(100)", require: "Y", normal: "Mr.Blue", describe: "收件人姓名" },
              { name: "postCode", type: "String(10)", require: "Y", normal: "59200", describe: "收件人邮编" },
              { name: "mobile", type: "String(30)", require: "Y", normal: "", describe: "收件人手机号码" },
              { name: "phone", type: "String(30)", require: this.$lang("不能和手机号同时为空"), normal: "", describe: "收件人电话" },
              { name: "area", type: "String(60)", require: "N", normal: "", describe: "收件乡镇" },
              { name: "city", type: "String(60)", require: "Y", normal: "", describe: "收件城市" },
              { name: "prov", type: "String(60)", require: "Y", normal: "TEST ADDRESS", describe: "收件人的省" },
              { name: "address", type: "String(200)", require: "Y", normal: "TEST ADDRESS", describe: "收件人地址" },
              { name: "countryCode", type: "String(10)", require: "N", normal: "THA", describe: "国家/地区code，例如CHN, BWN, IDN三字码;THA，泰国默认THA" },
            ]
          },
          {
            title: "packageInfo参数",
            value: [
              { name: "packageQuantity", type: "Integer", require: "Y", normal: "1", describe: "包裹总数量，默认写1,最大值999999" },
              { name: "weight", type: "Double", require: "Y", normal: this.$lang("50.121 单位是KG"), describe: "包裹总重量，支持3位小数(截取前3位小数)，长度不能超过9位" },
              { name: "height", type: "Double", require: "N", normal: "12", describe: "Height (cm)，长度不能超过9位" },
              { name: "length", type: "Double", require: "N", normal: "11", describe: "Length (cm)，长度不能超过9位" },
              { name: "width", type: "Double", require: "N", normal: "10", describe: "Width (cm)，长度不能超过9位" },
              { name: "multipleVotes", type: "Array", require: "N", normal: "", describe: "一票多件信息，包含主子单的实际重量、长、宽、高" }
            ]
          },
          {
            title: "offerFeeInfo参数",
            value: [
              { name: "isinsured", type: "boolean", require: "N", normal: "TRUE", describe: "是否保价" },
              { name: "offerfee", type: "String(9)", require: "N", normal: "", describe: "保价费" },
            ]
          },
          {
            title: "codInfo参数",
            value: [
              { name: "codValue", type: "String(9)", require: "N", normal: "", describe: "代收货款金额" },
            ]
          },
          {
            title: "items参数",
            value: [
              { name: "itemName", type: "String(80)", require: "Y", normal: "", describe: "商品名称(截取前80)" },
              { name: "number", type: "Double", require: "Y", normal: "", describe: "商品数量(1-999999)" },
              { name: "itemDesc", type: "String", require: "N", normal: "", describe: "商品描述(截取前200)" },
              { name: "itemValue", type: "Double", require: "Y", normal: "", describe: "物品单个价值(0.01-9999999.99)" },
            ]
          },
          {
            title: "multipleVotes参数",
            value: [
              { name: "weight", type: "String(0.01-999.99)", require: "Y", normal: "", describe: "包裹重量，支持2位小数，单位是KG" },
              { name: "length", type: "String(0.01-999.99)", require: "N", normal: "", describe: "长，单位是（cm）" },
              { name: "width", type: "String(0.01-999.99)", require: "N", normal: "", describe: "宽，单位是（cm）" },
              { name: "height", type: "String(0.01-999.99)", require: "N", normal: "", describe: "高，单位是（cm）" },
            ]
          },
        ],
        //参数描述  END
        //报文描述 start
        responseDataList: [

          //   响应参数
          {
            title: '响应参数',
            value: [
              { name: "code", type: "String(10)", require: "Y", normal: "1", describe: "1为成功 其他为失败,此时关注msg中返回的失败原因" },
              { name: "msg", type: "String(100)", require: "Y", normal: "", describe: "返回信息" },
              { name: "data", type: "Object", require: "Y", normal: "", describe: "业务数据" },
            ]
          },
          {
            title: "data参数",
            value: [
              { name: "logisticproviderid", type: "", require: "Y", normal: "JNT", describe: "物流公司代码" },
              { name: "txlogisticId", type: "String", require: "Y", normal: "", describe: "返回客户订单号" },
              { name: "billCode", type: "String", require: "Y", normal: "", describe: "返回运单号" },
              { name: "sortingCode", type: "String", require: "Y", normal: "", describe: "三段码" },
              { name: "streetSortingNo", type: "String", require: "N", normal: "", describe: "四段码" },
              { name: "success", type: "String", require: "Y", normal: "", describe: "是否成功" },
              { name: "reason", type: "String", require: "N", normal: "", describe: "错误原因" },
              { name: "createOrderTime", type: "Object", require: "Y", normal: "", describe: "订单创建时间 yyyy-MM-dd HH:mm:ss" },
              { name: "multipleVoteBillCodes", type: "Array", require: "N", normal: "", describe: "返回的一票多件信息运单号信息，包含主子单号。" },
            ]
          }

        ],
        //请求示例
        requestCode: `{
"actionType":"add",
"customerCode":"1192903707",
"txlogisticId":"TESTID000706",
"password":"7D302C5A99B968006454983FDBC4CCF2",
"orderType":1,
"serviceType":1,
"payType":"PP_PM",
"expressType":"EZ",
"deliveryType":1,
"shopId":"7493990580494632271",
"shopName":"hhyth01",
"goodsValue":"38.00",
"isSmallEcom":"0",
"sender": {
        "name": "rthyrhr",
        "postCode": "59200",
        "mobile": "145655454554",
        "phone": "34523",
        "prov": "Bangkok",
        "city": "Bang Kapi",
        "area": "Hua Mak",
        "address": "34/1หมู่6 ต บ้านน้อย อ จ"
    },
    "receiver": {
        "name": "dfhdh",
        "postCode": "55200",
        "mobile": "142225454554",
        "phone": "56746476",
        "prov": "Bangkok",
        "city": "Bang Kapi",
        "area": "Hua Mak",
        "address": "34/1หมู่6 ต บ้านน้อย อ จ"
    },
    "createOrderTime": "2024-06-04 15:59:52",
    "items": [
        {
            "itemName": "IPHONE12",
            "number": 999,
            "itemDesc": "dgasghsgasegsghse",
            "itemValue": 45.32
        }
    ],
    "packageInfo": {
        "packageQuantity": "3",
        "weight": "50.121",
        "height": "50.14",
        "length": "50.15",
        "width": "50.16",
        "multipleVotes": [
            {
                "weight": "21",
                "length": "12",
                "width": "12",
                "height": "12"
            },
            {
                "weight": "21",
                "length": "12",
                "width": "12",
                "height": "12"
            }
        ]
    },
    "sendStartTime": "2024-06-03 12:59:51",
    "sendEndTime": "2024-06-05 16:19:12",
    "offerFeeInfo": {
        "isinsured": true,
        "offerfee": "54.32"
    },
    "codInfo": {
        "codValue": "74.32"
    }
}`,
        //返回示例
        successCode: JSON.parse(`{
        "code": 1,
        "msg": "success",
        "data": {
                "txlogisticId": "YLTEST202404101519",
                "billCode": "870002864925",
                "sortingCode": "02-C51-PRK309",
                "thirdSortingCode": "S01",
                "multipleVoteBillCodes": ["870002864925", "870002864925-01"]
        },
        "requestId": "9e150ccfeda34150b900b4262cc085d1"
}`),
        failCode: JSON.parse(`{
          "code": 999002020,
          "msg": "txlogisticId Duplicate order number",
          "data": null,
          "fail": true,
          "succ": false
        }`),


        //错误代码提示
        errcodeJson: [
        ]
      },

      apiTestData: {
        _headerData: {
          apiAccount: "1001",
          digest: "U40e5sumorgd3YgZzU61Mw==",
          timestamp: "1565238848921",
        },
        data: {
          bizContent: `{"customerCode":"J0086000020","digest":"/bGMxZbpzAtLrplAvEYvqw==","serviceType":"02","countryCode":"CHN","orderType":"2","receiver":{"area":"鼓楼区","address":"南京大学","town":"鼓楼镇","city":"南京市","mobile":"12345678909","mailBox":"ant_li123@qq.com","phone":"075587654321","countryCode":"CHN","street":"大学路","name":"中露姐1","company":"上海天美工作室","postCode":"518000","prov":"江苏省"},"expressType":"EZ","deliveryType":"03","length":30,"sendStartTime":"2020-01-18 15:05:47","weight":20,"remark":"YD9945874130030","txlogisticId":"YL101010101011","goodsType":"bm000001","volume":210,"priceCurrency":"RMB","totalQuantity":6,"sender":{"area":"雨花台区","address":"高新技术产业园","town":"粤海街道","city":"南京市","mobile":"12345678909","mailBox":"ant_li@qq.com","phone":"075512345678","countryCode":"CHN","street":"高新南七道","name":"小露姐1","company":"深圳天丑工作室","postCode":"518000","prov":"江苏省"},"itemsValue":"2000","width":10,"offerFee":1000,"items":[{"englishName":"文件111","number":30,"itemType":"bm000001","itemName":"文件222","priceCurrency":"RMB","itemValue":"2000","chineseName":"文件333","itemUrl":"http://www.baidu.com/#h%?a=10&b=20","desc":"文件"},{"englishName":"文件444","number":50,"itemType":"bm000001","itemName":"文件555","priceCurrency":"RMB","itemValue":"3000","chineseName":"文件666","itemUrl":"http://www.baidu.com/#h%?a=10&b=20","desc":"文件000"}],"sendEndTime":"2020-01-19 15:05:47","height":600}`
        },
        //必须要验证的参数
        requestData: ['apiAccount', 'digest', 'timestamp', 'bizContent'],
        textareaData: {
          bizContent: true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,


      },
    };
  },
  created () { },
  methods: {
    handleClick (status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../css/apiTest.scss';
</style>